import {getJSON} from 'jquery';
import * as log from 'loglevel';
import * as _ from "lodash"
import * as ko from 'knockout';
import {ComputedOptions} from "~knockout/index";
import {getSecondaryScreenVisibilityOptions} from "../../ScreenVisibility";
import {Screen} from "../../Screen";
import {Observable} from '~knockout/index';


var template = require('./GameIntroScreen.html');

class GameIntroScreenComponent extends Screen
{
    overrideVisibility: Observable<boolean>;

    /**
     * create observable properties to let app elements communicate
     */
    createBindings()
    {
        super.createBindings();

        this.overrideVisibility = ko.observable(false);
    }



    /**
     * get screen visibility computed options
     * @returns {ComputedOptions<boolean>}
     */
    getVisibleOptions() : ComputedOptions<boolean>
    {
        return getSecondaryScreenVisibilityOptions('gameplay', 'game-intro');
    }


    /**
     * call a function when we show
     */
    onShow()
    {
        var timeline: TimelineMax;

        timeline = new TimelineMax({
            onStart: () =>
            {
                this.overrideVisibility(true);
            },
            onComplete: () =>
            {
                this.overrideVisibility(false);
            }});

        timeline.to('.pp-gameplay-game-intro-overlay', 0.5, { opacity: 1, ease: Expo.easeOut });
        timeline.fromTo('.game-intro-first', 0.5, { opacity: 0, marginTop: 10 }, { opacity: 1, marginTop: 0, ease: Back.easeOut }, 0.5);
        timeline.fromTo('.game-intro-second', 0.5, { opacity: 0, marginTop: 10 }, { opacity: 1, marginTop: 0, ease: Back.easeOut }, 0.75);
        timeline.fromTo('.game-intro-third', 0.5, { opacity: 0, marginTop: 20 }, { opacity: 1, marginTop: 0, ease: Back.easeOut }, 1.75);
        timeline.to('.pp-gameplay-game-intro-overlay', 0.5, { opacity: 0, ease: Expo.easeOut }, 3);
    }
}



/**
 * register this component with knockout
 * @param vizID
 */
export function registerGameIntroScreenComponent()
{
    ko.components.register('pp-gameplay-game-intro-overlay',
        {
            viewModel: () => { return new GameIntroScreenComponent() },
            template: template
        });
}


// WEBPACK FOOTER //
// ./src/ts/screens/gameplay/game-intro/GameIntroScreen.ts